import { useMemo, useState } from 'react';
import {
  buildArchiveName,
  buildAttachmentsArchive,
  collectMessageAttachments,
  downloadSeparately,
  saveBlob,
} from '../Services/attachmentsArchive';

export const ARCHIVE_MIN_ATTACHMENTS = 2;

export const hasArchivableAttachments = ({ images, files } = {}) =>
  collectMessageAttachments({ images, files }).length >= ARCHIVE_MIN_ATTACHMENTS;

const MessageArchiveDownload = ({ images, files }) => {
  const [isZipping, setIsZipping] = useState(false);

  const items = useMemo(() => collectMessageAttachments({ images, files }), [images, files]);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (isZipping) return;

    setIsZipping(true);
    try {
      saveBlob(await buildAttachmentsArchive(items, (item) => item.src), buildArchiveName());
    } catch (err) {
      console.error('Failed to build attachments archive, downloading files separately', err);
      downloadSeparately(items);
    } finally {
      setIsZipping(false);
    }
  };

  if (items.length < ARCHIVE_MIN_ATTACHMENTS) return null;

  const label = isZipping ? 'Creating archive…' : `Download all ${items.length} attachments as ZIP`;

  return (
    <button
      type="button"
      className={`file-download-link archive-download-link ${isZipping ? 'is-loading' : ''}`}
      onClick={handleClick}
      title={label}
      aria-label={label}
      aria-busy={isZipping ? 'true' : undefined}
      aria-disabled={isZipping ? 'true' : undefined}
    >
      {isZipping ? (
        <svg width="20" height="20" viewBox="0 0 50 50" aria-hidden="true">
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray="31.4 188.4"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.9s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          <path d="M14 3v5h5" />
          <path d="M10 3.5v.5M12 5.5v.5M10 7.5v.5" />
          <path d="M12 10.5v7" />
          <path d="M9.5 15 12 17.5l2.5-2.5" />
        </svg>
      )}
    </button>
  );
};

export default MessageArchiveDownload;
